<template>
	<div>
		<loading v-if="!loaded" />
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-100">
				<h3 class="order-title" style="display: flex;align-items: center;">
					ព័ត៌មានអំពីការដាក់ប្រាក់
					<!-- <router-link :to="'/deposits/edit/' + deposit.hash_id" v-if="deposit.deposit_status != 'dlv'">
						<md-button class="md-just-icon md-simple md-success">
							<md-icon>edit</md-icon>
							<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
						</md-button>
					</router-link> -->
				</h3>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">

				<md-table>
					<md-table-row>
						<md-table-cell style="width: 40%;">លេខកូដប្រតិបត្តិការ</md-table-cell>
						<md-table-cell style="width: 5px">:</md-table-cell>
						<md-table-cell>
							<span v-if="String(deposit.id).length > 0"><b>{{deposit.id}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>វិធីដាក់ប្រាក់</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(deposit.payment_type).length > 0"><b>{{deposit.payment_type}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ចំនួនទឹកប្រាក់</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(deposit.amount).length > 0"><b>{{config.moneylify(deposit.amount)}}</b> ({{deposit.currency}})</span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ឈ្មោះអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(deposit.name).length > 0"><b>{{deposit.username}} <md-icon class="verify" v-if="deposit.verified == 1">verified</md-icon> ({{deposit.name}}) ({{config.moneylify(deposit.balance)}})</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ទូរស័ព្ទអតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(deposit.phone).length > 0"><b>{{deposit.phone}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>រូបភាពប្រតិបត្តិការ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<!-- <h3>deposit Detail</h3> -->
				<md-table>

					<md-table-row>
						<md-table-cell>ថ្ងៃដាក់ស្នើ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(deposit.created_date).length > 0"><b>{{config.datelify(deposit.created_date)}}</b> ({{config.timelify(deposit.created_date)}})</span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ស្ថានភាព</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="String(deposit.status).length > 0">
								<span class="error" v-if="deposit.status == 2">{{ config.getDepositStatus(deposit.status) }}</span>
								<span class="green" v-if="deposit.status == 1">{{ config.getDepositStatus(deposit.status) }}</span>
								<span class="late" v-if="deposit.status == 0">{{ config.getDepositStatus(deposit.status) }}</span>
							</span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>អនុម័តដោយ</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="deposit.approve_by != null"><b>{{deposit.approve_by}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>ថ្ងៃអនុម័ត</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="deposit.approved_date != null"><b>{{config.datelify(deposit.approved_date)}}</b> ({{config.timelify(deposit.approved_date)}})</span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>

					<md-table-row>
						<md-table-cell>កំណត់ចំណាំទៅកាន់អតិថិជន</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="deposit.note_user != null"><b>{{deposit.note_user}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
					<md-table-row>
						<md-table-cell>កំណត់ចំណាំរបស់អ្នកគ្រប់គ្រង</md-table-cell>
						<md-table-cell>:</md-table-cell>
						<md-table-cell>
							<span v-if="deposit.note_admin != null"><b>{{deposit.note_admin}}</b></span>
							<span v-else>មិនមាន</span>
						</md-table-cell>
					</md-table-row>
				</md-table>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-33">
				<img :src="config.getTransactionUrl(deposit.transaction_url)" />
			</div>
			<div class="md-layout-item md-small-size-100 md-size-66">
				<div class="md-layout">
					<div class="md-layout-item md-small-size-70 md-size-66">
						<md-field>
							<label>កំណត់ចំណាំដើម្បីបង្ហាញទៅកាន់អតិថិជន</label>
							<md-input type="text" v-model="note.note_user"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-30 md-size-33">
						<md-button class="md-raised md-primary" @click="updateNoteUser()">រក្សាទុក</md-button>
					</div>

					<div class="md-layout-item md-small-size-70 md-size-66">
						<md-field>
							<label>កំណត់ចំណាំសម្រាប់អ្នកគ្រប់គ្រង</label>
							<md-input type="text" v-model="note.note_admin"></md-input>
						</md-field>
					</div>
					<div class="md-layout-item md-small-size-30 md-size-33">
						<md-button class="md-raised md-primary" @click="updateNoteAdmin()">រក្សាទុក</md-button>
					</div>
				</div>
			</div>

			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="confirmDeposit(deposit.id)" v-if="deposit.status == 0">យល់ព្រមដាក់ប្រាក់</md-button>
				<md-button class="md-raised md-danger" @click="rejectDeposit(deposit.id)" v-if="deposit.status == 0">បដិសេដការដាក់ប្រាក់នេះ</md-button>
			</div>
		</div>
		<md-dialog-confirm :md-active.sync="confirmDepositDialog" md-title="តើអ្នកពិតជាចង់យល់ព្រមសំណើនេះមែនឬ​?"
			md-content="" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="confirmDeposit" />
		<md-dialog-confirm :md-active.sync="rejectDepositDialog" md-title="តើអ្នកពិតជាចង់បដិសេដសំណើនេះមែនឬ?"
			md-content="" md-confirm-text="OK" md-cancel-text="បោះបង់" @md-cancel="onCancel" @md-confirm="rejectDeposit" />
	</div>
</template>
<script>
	import VueQRCodeComponent from 'vue-qr-generator'
	export default {
		components: {
			'qr-code': VueQRCodeComponent,
		},
		created() {
			this.getDeposit();
			// this.getPayment();
		},
		data() {
			return {
				loaded: false,
				paymentList: [],
				confirmDepositDialog: false,
				rejectDepositDialog: false,
				confirmDepositId: "",
				rejectDepositId: "",
				deposit: {
					id: "",
					payment_type: "",
					username: "",
					name: "",
					phone: "",
					transaction_url: "",
					created_date: "",
					approved_date: "",
					approve_by: "",
					note_user: "",
					note_admin: "",
					status: "",
					amount: 0
				},
				note: {
					note_user: "",
					note_admin: ""
				}
			}
		},
		methods: {
			getDeposit(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/deposit/get/" + this.$route.params.hash_id).then(data => {
					this.deposit = data.body.data
					this.note.note_user = data.body.data.note_user
					this.note.note_admin = data.body.data.note_admin
					// console.log(data.body.data)
					this.loaded = true
				})
			},
			confirmDeposit(id = "") {
				if(this.$store.state.authentication.account_type == 'ad' && parseFloat(this.deposit.amount) > 300) {
					this.$notification.notify({
						message: "សូមផ្តល់ដំណឹងទៅកាន់អ្នកគ្រប់គ្រងជាន់ខ្ពស់។",
						icon: 'error',
						type: 'danger'
					})
				} else {
					if (id == "" && String(this.confirmDepositId).length > 0) {
						this.$http.post(this.config.api + "/admin/deposit/confirm", {
							deposit_id: this.confirmDepositId
						}).then(data => {
							if (data.body.status == 'success') {
								this.$notification.notify({
									message: "បានយល់ព្រមដាក់ប្រាក់ដោយជោគជ័យ។",
									icon: 'done',
									type: 'success'
								})
								this.getDeposit();
								this.onCancel();
							}
						})
					} else {
						this.confirmDepositId = id;
						this.confirmDepositDialog = true;
					}
				}
			},
			rejectDeposit(id = "") {
				if (id == "" && String(this.rejectDepositId).length > 0) {
					this.$http.post(this.config.api + "/admin/deposit/reject", {
						deposit_id: this.rejectDepositId
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "បានយល់ព្រមដាក់ប្រាក់ដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getDeposit();
							this.onCancel();
						}
					})
				} else {
					this.rejectDepositId = id;
					this.rejectDepositDialog = true;
				}
			},
			updateNoteUser() {
				this.$http.post(this.config.api + "/admin/deposit/note", {
					deposit_id: this.deposit.id,
					type: "user",
					deposit_note: this.note.note_user
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រតិបត្តិការត្រូវបានកែប្រែកំណត់ចំណាំទៅកាន់អតិថិជនដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getDeposit();
						this.onCancel();
					}
				})
			},
			updateNoteAdmin() {
				this.$http.post(this.config.api + "/admin/deposit/note", {
					deposit_id: this.deposit.id,
					type: "admin",
					deposit_note: this.note.note_admin
				}).then(data => {
					if (data.body.status == 'success') {
						this.$notification.notify({
							message: "ប្រតិបត្តិការត្រូវបានកែប្រែកំណត់ចំណាំទៅសម្រាប់អ្នកគ្រប់គ្រងដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.getDeposit();
						this.onCancel();
					}
				})
			},
			onCancel() {
				this.confirmDepositDialog = false;
				this.confirmDepositId = "";
				this.rejectDepositDialog = false;
				this.rejectDepositId = "";
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Deposits/Detail.vue